import React from "react";
import ReactiveComponent from "@usereactify/search-internals/lib/components/basic/ReactiveComponent";

import { useFlags, useReactifySearchContext } from "../../hooks";
import { getPropsSensorPublished } from "../../utility/props";

export const SensorPublished: React.FC = () => {
  const flagsHook = useFlags();
  const reactifySearchContext = useReactifySearchContext();
  const reactiveProps = getPropsSensorPublished({
    config: reactifySearchContext.config,
    provider: reactifySearchContext.options,
  });

  if (!flagsHook.flags["reactify-search:flag_sensor_published"]) {
    return null;
  }

  return (
    <ReactiveComponent
      {...reactiveProps}
    />
  );
};
